/**
 * Http Client Mode enumeration
 */
export enum HttpResponseType
{
    ArrayBuffer = "arraybuffer",
    Blob = "blob",
    Json = "json",
    Text = "text"
}